import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { tryCatchHandlr } from "@shared/Utilities";

// eslint-disable-next-line import/prefer-default-export
export const getSuggestedAddressCheck = async ({
  streetAddress,
  secondaryAddress,
  city,
  locality,
  postalCode,
  country,
}) => {
  const [res, err] = await tryCatchHandlr(
    caseTransformingAxios.get("/api/v4/business_settings/suggest_standardized_address", {
      params: {
        streetAddress,
        secondaryAddress,
        city,
        locality,
        postalCode,
        country,
      },
    }),
  );

  return { res, err };
};
